'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgAdd, SvgMyFill, SvgShoppingBasketFill, SvgStore } from '@common/icon';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import { ServiceSwitchDropdown } from '@/app/_components/ServiceSwitchDropdown';
import { ROUTES, WEL_MARKET_ROUTES } from '@/constants';
import { useAdpopcorn } from '@/modules/adpopcorn';
const ANIMATION_DURATION = 300;
type LocalMarketBnbLinkItem = {
  kind: 'link';
  label: string;
  route: {
    pathname: string;
  };
  icon: typeof SvgStore;
};
type LocalMarketBnbAdpopcornItem = {
  kind: 'adpopcorn';
  label: '혜택';
};
type LocalMarketBnbItem = LocalMarketBnbLinkItem | LocalMarketBnbAdpopcornItem;
const LOCAL_MARKET_BNB_ITEMS: readonly LocalMarketBnbItem[] = [{
  kind: 'link',
  label: '홈',
  route: WEL_MARKET_ROUTES.HOME,
  icon: SvgStore
}, {
  kind: 'link',
  label: '장바구니',
  route: WEL_MARKET_ROUTES.CART,
  icon: SvgShoppingBasketFill
}, {
  kind: 'adpopcorn',
  label: '혜택'
}, {
  kind: 'link',
  label: '마이페이지',
  route: ROUTES.MY,
  icon: SvgMyFill
}];
interface LocalMarketBnbProps {
  className?: string;
}
export const LocalMarketBnb = t0 => {
  const $ = _c(42);
  const {
    className
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [menuClickAnimated, setMenuClickAnimated] = useState(t1);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const adpopcorn = useAdpopcorn();
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] !== adpopcorn || $[2] !== className || $[3] !== isDropdownOpen || $[4] !== menuClickAnimated || $[5] !== pathname) {
    let t7;
    if ($[11] !== adpopcorn) {
      t7 = item => item.kind !== "adpopcorn" || !adpopcorn.isExternalWebview;
      $[11] = adpopcorn;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    const visibleItems = LOCAL_MARKET_BNB_ITEMS.filter(t7);
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = index => {
        setMenuClickAnimated(prev => ({
          ...prev,
          [index]: true
        }));
        setTimeout(() => {
          setMenuClickAnimated(prev_0 => ({
            ...prev_0,
            [index]: false
          }));
        }, ANIMATION_DURATION);
      };
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    const handleMenuClick = t8;
    t4 = "\uC6F0\uB9C8\uCF19 \uB0B4\uBE44\uAC8C\uC774\uC158";
    if ($[14] !== className) {
      t5 = cn("relative mx-20 flex items-center rounded-pill bg-Gray-white p-8 shadow-[0px_0px_30px_0px_rgba(0,0,0,0.05),0px_16px_50px_0px_rgba(0,0,0,0.05)]", className);
      $[14] = className;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    let t9;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = () => setIsDropdownOpen(_temp);
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    let t10;
    if ($[17] !== isDropdownOpen) {
      t10 = cn("size-20 text-Gray-600 transition-transform duration-200", {
        "rotate-45": isDropdownOpen
      });
      $[17] = isDropdownOpen;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    let t11;
    if ($[19] !== t10) {
      t11 = <SvgAdd className={t10} />;
      $[19] = t10;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    let t12;
    if ($[21] !== isDropdownOpen || $[22] !== t11) {
      t12 = <button type="button" className="relative z-50 size-40 rounded-pill bg-Gray-200 flex-center" onClick={t9} aria-label={"\uB2E4\uB978 \uC11C\uBE44\uC2A4\uB85C \uC774\uB3D9"} aria-expanded={isDropdownOpen}>{t11}</button>;
      $[21] = isDropdownOpen;
      $[22] = t11;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    let t13;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = () => setIsDropdownOpen(false);
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    let t14;
    if ($[25] !== isDropdownOpen) {
      t14 = <ServiceSwitchDropdown isOpen={isDropdownOpen} onClose={t13} currentService="market" />;
      $[25] = isDropdownOpen;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    if ($[27] !== t12 || $[28] !== t14) {
      t6 = <div className="relative z-50">{t12}{t14}</div>;
      $[27] = t12;
      $[28] = t14;
      $[29] = t6;
    } else {
      t6 = $[29];
    }
    t2 = "flex flex-1 items-center justify-around px-12";
    let t15;
    if ($[30] !== adpopcorn || $[31] !== menuClickAnimated || $[32] !== pathname) {
      t15 = (item_0, index_0) => {
        const itemAnimationStyle = {
          animationDuration: `${ANIMATION_DURATION}ms`,
          transitionDelay: `${(index_0 + 1) * 60}ms`,
          transitionProperty: "transform",
          transitionDuration: "300ms"
        } as const;
        if (item_0.kind === "adpopcorn") {
          return <li key={item_0.label} className="w-53"><button type="button" onClick={() => {
              handleMenuClick(index_0);
              adpopcorn.onClick();
            }} disabled={adpopcorn.isOpening} className={cn("flex w-full flex-col items-center duration-150 disabled:opacity-60", menuClickAnimated[index_0] && "animate-jump")} style={itemAnimationStyle}><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="size-28"><path d="M14 2.33334C20.4327 2.3335 25.665 7.56632 25.665 13.9994C25.665 20.4324 20.4327 25.6652 14 25.6654C12.326 25.6654 10.6389 25.293 9.12402 24.5882C8.82622 24.4459 8.45627 24.4363 8.07715 24.557L5.09863 25.558C4.8773 25.6309 4.652 25.6663 4.43066 25.6664C3.88383 25.6664 3.35225 25.4512 2.9502 25.0492C2.38318 24.4832 2.1882 23.6608 2.43945 22.9046L3.44531 19.9124C3.56258 19.5451 3.55265 19.1759 3.41504 18.8851C2.70667 17.3618 2.33496 15.6746 2.33496 13.9994C2.335 7.56743 7.56839 2.33334 14 2.33334ZM13.999 8.31674C13.4235 8.31674 12.9062 8.63737 12.6514 9.15073L11.6318 11.2005L9.26855 11.5404C8.71217 11.6206 8.25944 12.0026 8.08594 12.5374C7.91267 13.071 8.05683 13.6445 8.45996 14.0345L10.1631 15.682L9.77539 17.9271C9.67744 18.4918 9.90498 19.0543 10.3691 19.3929C10.8345 19.7327 11.4435 19.7777 11.9531 19.5111L13.9971 18.4447L16.042 19.5121C16.2634 19.6269 16.5021 19.6849 16.7402 19.6849C17.0524 19.6848 17.3614 19.5863 17.627 19.3949C18.091 19.0562 18.3196 18.4961 18.2227 17.929L17.834 15.682L19.5371 14.0345C19.939 13.6445 20.0844 13.071 19.9111 12.5374C19.7388 12.0025 19.2849 11.6205 18.7285 11.5404L16.3652 11.2005L15.3457 9.15073C15.0897 8.63631 14.5732 8.31692 13.999 8.31674Z" fill="#D1D5DD" /></svg><p className="whitespace-nowrap text-center font-500 text-Gray-550 typo-caption2">{item_0.label}</p></button></li>;
        }
        const Icon = item_0.icon;
        const isActive = (() => {
          if (!pathname) {
            return false;
          }
          if (item_0.route.pathname === WEL_MARKET_ROUTES.HOME.pathname) {
            return pathname === item_0.route.pathname;
          }
          return pathname.includes(item_0.route.pathname);
        })();
        return <li key={item_0.label} className="w-53"><CustomLink href={item_0.route.pathname} aria-label={`${item_0.label} 페이지로 이동`} prefetch={true} className={cn("flex w-full flex-col items-center duration-150", menuClickAnimated[index_0] && "animate-jump")} style={itemAnimationStyle} onClick={() => handleMenuClick(index_0)}><Icon className={cn("size-28 text-Gray-400", {
              "text-Gray-black": isActive
            })} /><p className={cn("whitespace-nowrap text-center font-500 text-Gray-550 typo-caption2", {
              "font-600 text-Gray-900": isActive
            })}>{item_0.label}</p></CustomLink></li>;
      };
      $[30] = adpopcorn;
      $[31] = menuClickAnimated;
      $[32] = pathname;
      $[33] = t15;
    } else {
      t15 = $[33];
    }
    t3 = visibleItems.map(t15);
    $[1] = adpopcorn;
    $[2] = className;
    $[3] = isDropdownOpen;
    $[4] = menuClickAnimated;
    $[5] = pathname;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[34] !== t2 || $[35] !== t3) {
    t7 = <ul className={t2}>{t3}</ul>;
    $[34] = t2;
    $[35] = t3;
    $[36] = t7;
  } else {
    t7 = $[36];
  }
  let t8;
  if ($[37] !== t4 || $[38] !== t5 || $[39] !== t6 || $[40] !== t7) {
    t8 = <nav aria-label={t4} className={t5}>{t6}{t7}</nav>;
    $[37] = t4;
    $[38] = t5;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
  } else {
    t8 = $[41];
  }
  return t8;
};
function _temp(prev_1) {
  return !prev_1;
}